import createEvodicomTheme, { CustomThemeData } from './createEvodicomTheme';

// Keys ending in Light/Dark are read by getThemeNames/generateThemeDetailsMap
// to list the selectable themes; don't export other *Light/*Dark names here.
export const evodicomLight = createEvodicomTheme('light');
export const evodicomDark = createEvodicomTheme('dark');
export const customLight = (data: CustomThemeData) => createEvodicomTheme('light', data);
export const customDark = (data: CustomThemeData) => createEvodicomTheme('dark', data);
export { default as viewerTheme } from './viewer.theme';
